const OCCLUDER_SELECTOR = "[data-chat-disclaimer-occluder]";
const DISCLAIMER_SELECTOR = "[data-chat-disclaimer-slot] > *";
const STREAMING_CONTENT_CLEARANCE_PX = 32;

function rectanglesIntersect(
  first: DOMRect,
  second: DOMRect,
  clearance: number,
): boolean {
  return (
    first.top < second.bottom &&
    first.bottom + clearance > second.top &&
    first.left < second.right &&
    first.right > second.left
  );
}

/**
 * 最後の回答本文・操作が、表示上の安全余白を含めて注意文へ接近したか判定します。
 */
export function isChatDisclaimerOccluded(root: HTMLElement | null): boolean {
  const occluders = root?.querySelectorAll<HTMLElement>(OCCLUDER_SELECTOR);
  const disclaimer = root?.querySelector<HTMLElement>(DISCLAIMER_SELECTOR);

  if (!occluders || !disclaimer) {
    return false;
  }

  const disclaimerRect = disclaimer.getBoundingClientRect();
  return [...occluders].some((occluder) => {
    const clearance =
      occluder.dataset.chatDisclaimerOccluder === "content"
        ? STREAMING_CONTENT_CLEARANCE_PX
        : 0;
    return rectanglesIntersect(
      occluder.getBoundingClientRect(),
      disclaimerRect,
      clearance,
    );
  });
}

/**
 * 回答本文の伸長など、注意文との重なりを変える要素だけを監視します。
 */
export function observeChatDisclaimerOcclusionLayout(
  root: HTMLElement,
  onLayoutChange: () => void,
): () => void {
  if (typeof window.ResizeObserver !== "function") {
    return () => {};
  }

  const observer = new ResizeObserver(onLayoutChange);
  const disclaimer = root.querySelector<HTMLElement>(DISCLAIMER_SELECTOR);

  for (const occluder of root.querySelectorAll<HTMLElement>(
    OCCLUDER_SELECTOR,
  )) {
    observer.observe(occluder);
  }
  if (disclaimer) {
    observer.observe(disclaimer);
  }
  onLayoutChange();

  return () => {
    observer.disconnect();
  };
}
